import gql from 'graphql-tag';

export const OPERATION_CREATED = gql`
  subscription operationCreated($tenant_id: Int!) {
    operationCreated(tenant_id: $tenant_id) {
      id
      version
      sourceClientId
    }
  }
`;

export const OPERATION_UPDATED = gql`
  subscription operationUpdated($tenant_id: Int!, $operationId: Int) {
    operationUpdated(tenant_id: $tenant_id, operationId: $operationId) {
      id
      version
      dts
      sourceClientId
    }
  }
`;
